// import React from "react";
import Rating from "@mui/material/Rating";

interface Product {
  image: string;
  title: string;
  price: number;
  rating: {
    rate: number;
    count: number;
  };
}

const ProductCard: React.FC<{ singleProduct: Product }> = ({
  singleProduct,
}) => {
  const truncatedTitle =
    singleProduct.title.length > 20
      ? singleProduct.title.substring(0, 20) + "..."
      : singleProduct.title;

  return (
    <div className="bg-white shadow-md rounded-lg p-4 transform hover:scale-105 hover:shadow-xl transition duration-300 ease-in-out">
      {/* Image */}
      <div className="flex justify-center">
        <img
          className="h-40 w-auto object-contain rounded-md"
          src={singleProduct.image}
          alt={singleProduct.title}
        />
      </div>

      {/* Product Details */}
      <div className="mt-4">
        {/* Title */}
        <h3 className="text-sm font-semibold text-gray-700 hover:text-blue-600 transition">
          {truncatedTitle}
        </h3>

        {/* Rating */}
        <div className="flex items-center mt-2">
          <Rating
            value={singleProduct.rating.rate}
            precision={0.1}
            readOnly
            size="small"
          />
          <small className="ml-2 text-xs text-gray-500">
            ({singleProduct.rating.count})
          </small>
        </div>

        {/* Price */}
        <p className="mt-3 text-lg font-semibold text-blue-600">
          ${singleProduct.price.toFixed(2)}
        </p>
      </div>
    </div>
  );
};

export default ProductCard;
